const headersDevices = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'IP адрес',
    value: 'ip_address',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
  },
  {
    text: 'Модель устройства',
    value: 'model',
  },
  {
    text: 'Произвоитель устройства',
    value: 'manufacturer',
  },
];
const headersPlanBeward = [
  {
    text: 'Номер квартиры',
    value: 'Number',
    align: 'center',
    class: 'table-custom-header wrap-text',
  },
  {
    text: 'sip логин',
    value: 'Phone1',
    align: 'center',
    class: 'table-custom-header',
  },
  {
    text: 'sip логин 2',
    value: 'Phone2',
    align: 'center',
    class: 'table-custom-header',
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    class: 'table-custom-header',
    width: '280px',
  },
  {
    text: 'Переговорное устройство',
    value: 'PhonesActive',
    align: 'center',
    class: 'table-custom-header wrap-text',
  },
  {
    text: '',
    value: 'actions',
  },
];

const headersPlan = [
  {
    text: 'id',
    value: 'ID',
    align: 'center',
    class: 'table-custom-header',
  },
  {
    text: 'Номер квартиры',
    value: 'Prefix',
    align: 'center',
    class: 'table-custom-header wrap-text',
  },
  {
    text: 'sip логин',
    value: 'Login',
    align: 'center',
    class: 'table-custom-header wrap-text',
  },
  {
    text: 'sip логин 2',
    value: 'Replace',
    align: 'center',
    class: 'table-custom-header',
  },
  {
    text: 'Аналог',
    value: 'Replace5',
    align: 'center',
    class: 'table-custom-header',
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    class: 'table-custom-header',
    width: '260px',
  },
  {
    text: 'Переговорное устройство',
    value: 'IsActive',
    align: 'center',
    class: 'table-custom-header wrap-text',
  },
  {
    text: '',
    value: 'actions',
  },
];
const headersPlanRubetekRV3434 = [
  {
    text: 'Номер квартиры',
    value: 'Prefix',
    align: 'center',
    width: '340px',
    class: 'table-custom-header wrap-text',
  },
  {
    text: 'sip логин',
    value: 'Login',
    align: 'center',
    width: '340px',
    class: 'table-custom-header wrap-text',
  },
  {
    text: 'Комментарий',
    value: 'Comment',
    align: 'center',
    class: 'table-custom-header',
    width: '340px',
  },
  {
    text: 'Переговорное устройство',
    value: 'IsActive',
    align: 'center',
    class: 'table-custom-header wrap-text',
  },
  {
    text: '',
    align: 'start',
    value: 'actions',
    width: '120px',
    sortable: false,
  },
];

const headersDoors = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Отображение двери',
    value: 'isActive',
  },
  {
    text: 'Отображение отдельной строкой',
    value: 'separate',
  },
  {
    text: 'Номер двери',
    value: 'doornum',
  },
  {
    text: 'Держать дверь открытой',
    value: 'doorOpen',
  },
  {
    text: 'Название',
    value: 'name',
    width: 300,
  },
  {
    text: '',
    value: 'actions',
    align: 'center',
  },
];
const headersDoorsRubetek3438 = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Отображение двери',
    value: 'isActive',
  },
  {
    text: 'Отображение отдельной строкой',
    value: 'separate',
  },
  {
    text: 'Номер двери',
    value: 'doornum',
  },
  {
    text: 'Название',
    value: 'name',
    width: 300,
  },
  {
    text: '',
    value: 'actions',
    align: 'center',
  },
];

const rules = {
  universal: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
  cHeatThresHold: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
  number: [
    v => v >= 0 || 'Введите целое число',
  ],
  VolumeRubetek: [
    v => !!v || 'Поле обязательно для заполнения',
    v => v >= 0 || 'Введите целое число',
    v => (v && v >= 1 && v <= 16) || 'Диапазон от 1 до 15',
  ],
  audio: [
    v => !!v || 'Поле обязательно для заполнения',
    v => v >= 0 || 'Введите целое число',
    v => (v && v >= 1 && v <= 16) || 'Диапазон от 1 до 16',
  ],
  Vol: [
    v => !!v || 'Поле обязательно для заполнения',
    v => v >= 0 || 'Введите целое число',
    v => (v && v >= 1 && v <= 20) || 'Диапазон от 1 до 20',
  ],
  SystemVol: [
    v => !!v || 'Поле обязательно для заполнения',
    v => v >= 0 || 'Введите целое число',
    v => (v && v >= 1 && v <= 4) || 'Диапазон от 1 до 4',
  ],
  code: [
    v => !v || (v && v.length >= 3 && v.length <= 8) || 'Длина кода должна быть не менее 3 и не более 8 символов',
  ],
  conciergeNumber: [
    v => v >= 0 || 'Введите целое число',
    v => /^\d{11}$/.test(v) || 'Введите 11 цифр',
  ],
  requiredNumber: [
    v => !!v || 'Поле обязательно для заполнения',
    v => v >= 0 || 'Введите целое число',
  ],
  sound: [
    v => !!v || 'Обязательное поле',
    v => !v || v.name.split('.').pop() === 'wav' || 'Аудиофайл должен быть в формате WAV',
    v => !v || v.size < 200000 || 'Размер не должен превышать больше 200Кб ',
  ],
  keys: [
    v => !!v || 'Обязательное поле',
  ],
  textDoor: [
    v => !!v || 'Обязательное поле',
    v => (v.length > 0 && v.length < 30) || 'Сообщение должно быть от 1 до 30 символов',
  ],
  adminCode: [
    v => !v || (v && v.length >= 4 && v.length <= 4) || '4-значный номер',
  ],
  massages: [
    v => v.length <= 50 || 'Максимум 50 символов',
  ],
};

const HEAT_SWITCH_STATUS = {
  true: 'Включен',
  false: 'Выключен',
};

const ECHO_CANCELLATION = {
  true: 'Эхоподавление включено',
  false: 'Эхоподавление выключено',
};

const paymentTypes = [
  {
    id: 'A',
    payment_type: 'Оплата через мобильное приложение',
  },
  {
    id: 'M',
    payment_type: 'Оплата через управляющую компанию',
  },
  {
    id: 'G',
    payment_type: 'Калитка',
  },
];
const contractTypes = [
  {
    id: 'M',
    contract_type: 'Договор с УК',
  },
  {
    id: 'I',
    contract_type: 'Индивидуальный договор',
  },
]
;const tubeInstallation = [
  {
    id: 'Y',
    name: 'Да',
  },
  {
    id: 'N',
    name: 'Нет',
  },
  {
    id: 'IC',
    name: 'Через интернет кабель',
  },
];
const creatureDoorphonePaymentTypes = [
  {
    id: 'A',
    payment_type: 'Оплата через мобильное приложение',
  },
  {
    id: 'M',
    payment_type: 'Оплата через управляющую компанию',
  },
];

const dateFormats = [
  'ГГГГ-ММ-ДД',
  'ГГГГ/ММ/ДД',
  'ДД-ММ-ГГГГ',
  'ДД/ММ/ГГГГ',
  'НН-ДД-ММ',
  'НН-ММ-ДД',
];

const timeFormats = [
  '12 часов',
  '24 часа',
];

const LCD = [
  { welcome_display: 0, type: 'Стандартное сообщение' },
  { welcome_display: 1, type: 'Пользовательское сообщение' },
  { welcome_display: 2, type: 'Стандартное изображение' },
  { welcome_display: 3, type: 'Пользовательское изображение' },
];

const SEPARATE_OPEN_DOOR = {
  true: 'Открытая дверь',
  false: 'Открытая дверь',
  null: 'Не редактируется',
};

const physicalStatus = [
  { id: 1, status: 'Установлен' },
  { id: 2, status: 'Не установлен' },
  { id: 3, status: 'Без интернет соединения' },
  { id: 4, status: 'Пусконаладка' },
  { id: 5, status: 'Старый домофон' },
];
const physicalStatusWithoutDevice = [
  { id: 5, status: 'Старый домофон' },
  { id: 6, status: 'Ожидает монтожа' },
];
const freeKeys = [
  { id: 'OA', text: '1 ключ на квартиру' },
  { id: 'TA', text: '2 ключа на квартиру' },
  { id: 'OO', text: '1 ключ на собственника' },
];
const issuanceFreeKeys = [
  { id: 'AG', text: 'Председатель МКД / Активная группа' },
  { id: 'MC', text: 'Управляющая компания' },
  { id: 'SD', text: 'Абонентский отдел (согласно района)' },
  { id: 'D', text: 'Застройщик' },
  { id: 'A', text: 'Агент' },
  { id: 'C', text: 'Указано в комментарии' },
];

const oldIntercoms = [
  { text: 'Laskomex AO-3000' },
  { text: 'Визит SM-101' },
  { text: 'Визит БВД-313' },
  { text: 'Визит БВД-316' },
  { text: 'Визит БВД-343' },
  { text: 'Визит БВД-343 MF' },
  { text: 'Визит БВД-432' },
  { text: 'Маршал' },
  { text: 'Метаком МК2003.1' },
  { text: 'Метаком МК2003.2' },
  { text: 'Метаком МК2012' },
  { text: 'Метаком МК20' },
  { text: 'Цифрал' },
];

export {
  tubeInstallation, creatureDoorphonePaymentTypes, headersDoorsRubetek3438, physicalStatus, issuanceFreeKeys, freeKeys,
  SEPARATE_OPEN_DOOR, ECHO_CANCELLATION, HEAT_SWITCH_STATUS, headersDoors, headersDevices, headersPlan, LCD, rules,
  dateFormats, timeFormats, paymentTypes, contractTypes, headersPlanBeward, headersPlanRubetekRV3434, oldIntercoms,
  physicalStatusWithoutDevice,
};
